<template>
	<div class="container-fluid bg-default-color">
		<service-toolbar>
			<button v-if="$route.params.id == 'new-quote'" type="button" class="btn btn-light" v-on:click="copyFromQuoteTemplate">
				<i class="fa fa-copy"></i>
				Copy from a Quote Template...
			</button>
		</service-toolbar>

		<vue-form :working="statusWorking" :readonly="readonly" v-on:submit="saveService" :save-buttons-hidden="$store.service.is_emergency == null" :save-button-fixed="true">

			<collapsible-panel v-if="$store.service.is_emergency != null" :always-open="!schedulePanelOpen || activeSection != 'Scheduling'" :external-toggle="!schedulePanelOpen || activeSection != 'Scheduling'" panel-size="md">

				<template slot="panel">
					<div v-if="$route.params.id != 'new' && 'slug' in $store.service" style="margin-bottom: 20px;">

						<button v-if="$store.service.archived == 0" class="btn btn-light" type="button" v-on:click="archiveService">
							<i class="fa fa-archive"></i> Archive Service
						</button>

						<button v-else class="btn btn-light" type="button" v-on:click="archiveService">
							<i class="fa fa-archive"></i> Un-Archive Service
						</button>

					</div>

					<panel-menu 
						:menu-items="serviceSections"
						:active-item="activeSection"
						v-on:itemClick="activateSection">
					</panel-menu>

					<div v-if="!isNew" class="mt-3">
						<a class="text-danger" href="#" v-on:click.prevent="deleteServiceModalVisible = true">
							<i class="fa fa-trash"></i> Delete {{ isQuote ? 'Quote' : 'Service' }}...
						</a>
					</div>
				</template>
				<template slot="main">

					<div class="d-flex">
						<div v-if="schedulePanelOpen" class="panel-filler"></div>
						<div v-if="activeSection != 'Scheduling'" class="d-flex flex-row justify-content-between flex-wrap mb-2 align-items-center">
							<div>
								
								<h2 style="margin-bottom: 0;margin-right: 10px;">
									{{serviceHeadingTitle}}<br>
									<small class="text-muted">{{serviceHeadingSmall}}</small>
								</h2>
								<div class="text-muted" v-if="'UpdatedBy' in $store.service">Last edited by {{ $store.service.UpdatedBy.first_name }} {{ $store.service.UpdatedBy.last_name }} @ {{ formatDateTimeToLocal($store.service.updated_at) }}</div>

							</div>
							<div v-if="!isNew">
								<template v-if="!showHeaderStatusSelect">
									<div class="text-center alert status-state m-0"
										:class="{
											'alert-success': !serviceStatusIncompleteGroup,
											'alert-warning': serviceStatusIncompleteGroup
										}">{{$store.service.status}}
									</div>

									<div v-if="serviceStatusIsCompletedGroup($store.service.status)" class="text-right">Completed at <span :class="{'text-danger' : !moment($store.service.completed).isValid()}">{{formatDate($store.service.completed)}}</span></div>
									<div class="text-right" v-if="!readonly && !isNew">
										<button 
											class="btn btn-link" 
											type="button" 
											v-on:click="showHeaderStatusSelect = true">Change...
										</button>
									</div>
								</template>

								<template v-else>
									<field
										:params="{type:'select',options:serviceStatusOptions()}" 
										v-model="$store.service.status" 
										:readonly="readonly || (isQuote && isNew)" :invalid="$store.errorList.status"
										v-on:change="statusChange($event,true)">
									</field>
								</template>
								<field 
									v-if="showHeaderStatusSelect && serviceStatusIsCompletedGroup($store.service.status)"
									label="Completed On" 
									col-class="col-6 col-sm-3 col-md-6 col-lg-4" 
									:params="{type:'date'}" 
									v-model="$store.service.completed" 
									:readonly="readonly"
									v-on:change="statusChange($event,true)">
								</field>

								<field v-if="showHeaderStatusSelect && $store.service.status == 'Canceled'" 
									label="Cancelation Reason" 
									col-class="col-6 col-sm-3 col-md-6 col-lg-4" 
									v-model="$store.service.canceled_reason" 
									:params="{type:'textarea'}"
									v-on:change="cancelService">

									<div>Enter a cancelation reason to confirm the cancelation</div>
								</field>
								
							</div>
						</div>
					</div>

					<hr v-if="activeSection != 'Scheduling'">
					<section v-if="activeSection == 'Details'" class="thin-section">

						<qbo-job-sync-alert v-if="'id' in $store.service && $store.service.id > 0 && qboIsActive"
							:job="$store.service"
							api-resource="Service"
							v-on:qboIdSet="$store.service.qbo_id = $event">		
						</qbo-job-sync-alert>

						<customer-section
							:customer-service-contract-options="customerServiceContractOptions"
							:readonly="readonly"
							:is-new-emergency="isNewEmergency"
							v-on:contractSelected="contractSelected"
							v-on:contractOptionsChange="contractOptionsChange"
							v-on:customerSelected="fetchCustomerLocations"
							v-on:newCustomer="newCustomerModalVisible = true">
						</customer-section>

						<field 
							label="Project" 
							col-class="col-sm-6 col-md-3 col-lg-2" 
							:params="{type:'select',options:mutatedJobOptions}"
							v-model="$store.service.job_id">
						</field>

					</section>

					<section v-if="activeSection == 'Details'" class="thin-section">
						<h3>Service Work Details</h3>

						<div class="row" v-if="$route.params.id != 'new'">
							<div class="col-md-6 col-sm-12">
								<field v-if="$store.service.status != 'Quote'"
									label="WO Type" 
									col-class="col-6 col-sm-3 col-md-6 col-lg-4" 
									v-model="$store.service.is_emergency" 
									:params="{
										type: 'btn-group',
										buttons:[
											{text: 'Normal',value:0},{text: 'Emergency',value:1}
										],
										disableNull: true
									}" 
									:readonly="readonly" :invalid="$store.errorList.is_emergency">	
								</field>
							</div>
							<div class="col-md-6 col-sm-12">
								<!--<field 
									label="Status" 
									col-class="col-6 col-sm-3 col-md-6 col-lg-4" 
									:params="{type:'select',options:serviceStatusOptions()}" 
									v-model="$store.service.status" 
									:readonly="readonly || (isQuote && isNew)" :invalid="$store.errorList.status"
									v-on:change="statusChange">
								</field>

								<field 
									v-if="serviceStatusIsCompletedGroup($store.service.status)"
									label="Completed Date" 
									col-class="col-6 col-sm-3 col-md-6 col-lg-4" 
									:params="{type:'date'}" 
									v-model="$store.service.completed" 
									:readonly="readonly">
								</field>

								<field v-if="$store.service.status == 'Canceled'" 
									label="Cancelation Reason" 
									col-class="col-6 col-sm-3 col-md-6 col-lg-4" 
									v-model="$store.service.canceled_reason" 
									:params="{type:'textarea'}">
								</field>
							-->
							</div>
						</div>

						<field v-if="$route.params.id != 'new' && !isNewEmergency" 
							:label="$store.service.status == 'Quote' ? 'Quote #' : 'Service #'" 
							col-class="col-md-3 col-lg-2" 
							v-model="$store.service.job_num" 
							:readonly="readonly || !('CompanySetting' in $store.company) || !$store.company.CompanySetting || $store.company.CompanySetting.editable_service_nums == 0" :invalid="$store.errorList.job_num">
						</field>

						<field 
							:label="$store.service.status == 'Quote' ? 'Quote Name' : 'Service Name'" 
							col-class="col-sm-3 col-md-3 col-lg-2" 
							v-model="$store.service.job_name" 
							:readonly="readonly" :invalid="$store.errorList.job_name">
						</field>

						<field v-if="$store.service.status != 'Quote' && !isNewEmergency"
							label="Warranty Work" 
							col-class="col-sm-6 col-md-3 col-lg-2" 
							:params="{type:'boolean'}"
							v-model="$store.service.is_warranty_work">
						</field>

						<field 
							label="Work To-Do" 
							col-class="col-md-3 col-lg-2" 
							v-model="$store.service.description" 
							:params="{type: 'richtext'}" 
							:readonly="readonly"
							:invalid="$store.errorList.description"
							v-on:input="workToDoChange">
						</field>

						<template v-if="!isNewEmergency">
							<field 
								:label="$store.service.status == 'Quote' ? 'Quote Date' : 'P.O. Date'" 
								col-class="col-md-3 col-lg-2" 
								v-model="$store.service.date_landed" 
								:params="{type: 'date'}" 
								:readonly="readonly" :invalid="$store.errorList.date_landed">
							</field>

							<field 
								label="Permit Required" 
								col-class="col-md-3 col-lg-2" 
								v-model="$store.service.permit_needed" 
								:params="{type: 'boolean'}" 
								:readonly="readonly" :invalid="$store.errorList.permit_needed">
							</field>
						</template>

						<template v-if="$store.service.permit_needed == 1">

							<div class="row">
								<div class="col-md-6 col-sm-12">
									<field label="Inspector Number" 
										col-class="col-5 col-sm-3 col-md-6 col-lg-4" 
										v-model="$store.service.inspector_num" 
										 
										:readonly="readonly" :invalid="$store.errorList.inspector_num">
									</field>

									<field label="Inspector Name" 
										col-class="col-5 col-sm-3 col-md-6 col-lg-4" 
										v-model="$store.service.inspector_name" 
										:readonly="readonly" :invalid="$store.errorList.inspector_name">
									</field>

									<field label="Inspector Email" 
										col-class="col-5 col-sm-3 col-md-6 col-lg-4" 
										v-model="$store.service.inspector_email" 
										:readonly="readonly" :invalid="$store.errorList.inspector_email">
									</field>
								</div>
								<div class="col-md-6 col-sm-12">
									<field label="Permit Cost" 
										col-class="col-5 col-sm-3 col-md-6 col-lg-4" 
										v-model="$store.service.permit_cost" 
										:params="{type:'number',min:0, step:0.01}" 
										:readonly="readonly" :invalid="$store.errorList.permit_notification_number">
									</field>

									<field label="Notification Number" 
										col-class="col-5 col-sm-3 col-md-6 col-lg-4" 
										v-model="$store.service.permit_notification_number" 
										:readonly="readonly" :invalid="$store.errorList.permit_notification_number">
									</field>
								</div>
							</div>

						</template>

						<field label="Has Locates" 
							col-class="col-md-3 col-lg-2" 
							v-model="$store.service.has_locates" 
							:params="{type: 'boolean'}"
							:readonly="readonly">

							<p v-if="$store.service.has_locates == 1 && $route.params.id != 'new'" class="mt-1">
								<router-link to="locates">Go to locates...</router-link>
							</p>

						</field>

						<field 
							label="Internal Notes" 
							col-class="col-md-3 col-lg-2" 
							v-model="$store.service.internal_notes" 
							:params="{type: 'textarea'}" 
							:readonly="readonly" :invalid="$store.errorList.internal_notes">
						</field>

					</section>
					
					<section v-if="!isNewEmergency && activeSection == 'Details'" class="thin-section">
						<categorization-section
							:is-new-emergency="isNewEmergency"
							:readonly="readonly"
							v-on:categorySelected="categorySelected">
						</categorization-section>
					</section>
					
					<section v-else-if="activeSection == 'Contacts'">

						<h3>Contacts</h3>

						<contact-table 
							v-if="!isNewEmergency"
							:readonly="readonly"
							record-type="service" 
							:contacts="$store.service.ServiceContact" 
							:new-record="$route.params.id == 'new'"
							:record-id="$store.service.id"
							v-on:contactAdded="fetchContacts"
							v-on:contactRemoved="fetchContacts">
						</contact-table>

					</section>
					<section v-else-if="activeSection == 'Work Location'">

						<h3>Work Location</h3>

						<field 
							:params="{type: 'btn-group',buttons:locationButtons,disableNull:true}"
							v-on:change="locationTypeChange"
							v-model="$store.service.location_type" 
							:readonly="readonly" :invalid="$store.errorList.location_type">

							<div class="mt-2 row">

								<div class="col-md-6" v-if="$store.service.location_type != 'pin'">
									

										<!--
										<iframe
											width="100%"
											height="300"
											frameborder="0" style="border:0"
											:src="mapsSrc" allowfullscreen>
										</iframe>
									-->

									<job-map v-if="'lat' in $store.service && 'long' in $store.service && !isNaN(+$store.service.lat) && !isNaN(+$store.service.long) && $store.service.lat && $store.service.long"
										style="margin-bottom:10px;"
										key="location-map"
										:job-location="{
											lat: +$store.service.lat,
											lng: +$store.service.long
										}"
										:check-in-tolerance="+$store.service.check_in_tolerance"
										:map-zoom="7">
									</job-map>

										<!--
											<button v-if="!showDirectionsOnMap" class="btn btn-light" style="width: 100%;" v-on:click="showDirectionsOnMap = true">
												<i class="fa fa-map"></i>
												Show Driving Directions
											</button>
										-->

									<div v-else class="text-center mt-4">
										<i class="fa fa-map fa-5x"></i>
										<p>Enter an address and save the service to plot a map</p>
									</div>
								</div>

								<div :class="{'col-md-6': $store.service.location_type != 'pin','col-md-12' : $store.service.location_type == 'pin'}">

									<address-manual-selector v-if="$store.service.location_type == 'address'"
										:suite="$store.service.suite"
										:address="$store.service.address"
										:city="$store.service.city"
										:province="$store.service.province"
										:country="$store.service.country"
										:postal-code="$store.service.postal_code"
										:readonly="readonly"
										v-on:input="debounce('updateLocation',$event,1000)"
										:invalid-list="$store.errorList">

										<template slot="bottom">

											<button type="button" class="btn btn-light btn-sm float-right mt-1 mb-2" v-on:click="openLocationModal($store.service)">
												<i class="fa fa-plus"></i>
												Add to Customer
											</button>
											<div style="clear: both;"></div>

											<div v-if="addressChangeWarningVisible" class="alert alert-info">
												If you update the address, the following fields must be filled out and valid, otherwise the map encoding for the new address will fail and revert to the previous location:

												<ul>
													<li>Address</li>
													<li>City</li>
													<li>Province/State</li>
													<li>Postal Code</li>
												</ul>

											</div>

										</template>

									</address-manual-selector>

									<template v-else-if="$store.service.location_type == 'coord'">
										<div class="muted offset-md-3" style="padding-left: 10px;">Enter lat/longs in decimal degrees</div>
										<field 
											label="Latitude" 
											col-class="col-md-3" 
											:params="{placeholder: 'ex. 44.12342'}" 
											v-model="$store.service.lat"
											v-on:change="updatePinLocation"
											:readonly="readonly" :invalid="$store.errorList.lat">
										</field>
										<field 
											label="Longitude" 
											col-class="col-md-3" 
											:params="{placeholder: 'ex. -82.4216'}" 
											v-model="$store.service.long"
											v-on:change="updatePinLocation"
											:readonly="readonly" :invalid="$store.errorList.long">
										</field>
									</template>

									<template v-else-if="$store.service.location_type == 'pin'">
										<div>Drag the pin to the location of the Work Order</div>

										<input v-if="$store.service.lat && $store.service.long" type="text" readonly class="form-control text-center" v-model="'Lat: '+ $store.service.lat + ' Long: ' + $store.service.long">

										<vue-map
											style="margin-bottom:10px;"
											key="drop-pin-map"
											:center="{
												lat: !isNaN(+$store.service.lat) ? +$store.service.lat : +$store.company.lat ? +$store.company.lat : 43,
												lng: !isNaN(+$store.service.long) ? +$store.service.long : +$store.company.long ? +$store.company.long : -79
											}"
											:zoom="7"
											map-size="map-sm"
											:markers="dropMarkers"
											v-on:markerDrop="setCoordsFromDroppedPin">
										</vue-map>
									</template>
									
									<template v-else-if="$store.service.location_type == 'contact-location'">

										<form-group label="Customer Locations"
											col-class="stacked">

											<div class="d-flex">

												<field
													style="flex-grow: 1;"
													:params="{type:'select',options:customerLocationsOptions}"
													v-model="$store.service.contact_location_id"
													v-on:change="contactLocationChange">
												</field>

												<button  style="min-width: 150px;" type="button" class="btn btn-light btn-attached" v-on:click="openLocationModal">
													<i class="fa fa-plus"></i>
													New Location
												</button>

											</div>
										</form-group>


										<address-manual-selector
											class="mt-3"
											:suite="$store.service.suite"
											:address="$store.service.address"
											:city="$store.service.city"
											:province="$store.service.province"
											:country="$store.service.country"
											:postal-code="$store.service.postal_code"
											:readonly="true">
										</address-manual-selector>

									</template>
								</div>
							</div>

						</field>

					</section>
					
					<section v-if="!isNewEmergency && activeSection == 'Setup Options'" class="thin-section">
						<h3>Setup Options</h3>

						<field v-if="$store.payBoostOptions.length > 0"
							label="Pay Adjustments for Time Log" 
							col-class="col-lg-3 col-md-4 col-sm-6" 
							v-model="$store.service.payboost_ids" 
							:params="{type: 'select-multi', options: $store.payBoostOptions}" 
							:readonly="readonly">	
						</field>
						<div v-else class="d-flex align-items-center mb-2">
							Pay Adustments not set up yet. <router-link v-if="hasModulePermWrite('Settings') && hasModulePermWrite('Users')" to="/employees/pay-adjustments">Add some</router-link>
						</div>	

						<field 
							:label="checkinToleranceLabel" 
							col-class="col-lg-3 col-md-4 col-sm-6" 
							v-model="$store.service.check_in_tolerance" 
							:params="{type: 'select', options: checkinToleranceOptions}" 
							:readonly="readonly"
							:invalid="$store.errorList.check_in_tolerance">
						</field>

						<p v-if="$store.service.contract_id > 0">The remaining setup options are set on the service contract</p>

						<template v-for="(union,index) in $store.unions" v-if="$store.projectUnionCollectiveAgreements">

							<field 
								:label="'Compensation Schedule for '+union.union_name" 
								col-class="col-lg-3 col-md-4 col-sm-6" 
								:params="{type: 'select', 
								options: collectiveAgreementOptions(union.id)}" v-model="$store.projectUnionCollectiveAgreements[union.id]" 
								:readonly="readonly || $store.service.contract_id > 0">
							</field>

						</template>

						<template v-if="$store.unions.length > 0">
							<field 
								label="Mileage Pay" 
								col-class="col-lg-3 col-md-4 col-6" 
								v-model="$store.service.pays_mileage" 
								:params="{type: 'boolean'}" 
								:invalid="$store.errorList.pays_mileage"
								:readonly="readonly || $store.service.contract_id > 0">
							</field>

							<field 
								label="Per Diem Pay" 
								col-class="col-lg-3 col-md-4 col-6" 
								v-model="$store.service.pays_perdiem" 
								:params="{type: 'boolean'}" 
								:invalid="$store.errorList.pays_perdiem"
								:readonly="readonly || $store.service.contract_id > 0">
							</field>
						</template>

						<field
							label="Disable Work To Do Signature"
							col-class="col-lg-3 col-md-4 col-6"
							v-model="$store.service.work_to_do_disabled"
							:params="{type: 'boolean'}"
							:invalid="$store.errorList.work_to_do_disabled"
							:readonly="readonly">
						</field>

						<field
							label="Disable Work Order Signature"
							col-class="col-lg-3 col-md-4 col-6"
							v-model="$store.service.work_orders_disabled"
							:params="{type: 'boolean'}"
							:invalid="$store.errorList.work_orders_disabled"
							:readonly="readonly">
						</field>

						<field
							label="Customer Assets"
							col-class="col-lg-3 col-md-4 col-6"
							v-model="selectedCustomerAssetIds"
							:params="{type: 'select-multi', options: customerAssetOptions}"
							:readonly="readonly">
						</field>

						<field
							label="Form Child Templates"
							col-class="col-lg-3 col-md-4 col-6"
							v-model="selectedFormChildTemplateIds"
							:params="{type: 'select-multi', options: formChildTemplateOptions}"
							:readonly="readonly">
						</field>

						<field
							label="Checklists"
							col-class="col-lg-3 col-md-4 col-6"
							v-model="selectedChecklistIds"
							:params="{type: 'select-multi', options: checklistOptions}"
							:readonly="readonly">
						</field>


					</section>

					<section v-else-if="activeSection == 'Personnel Roles'">
						<personnel-tab v-if="!isNew" 
							:is-sub-component="true" 
							:no-widget="true" 
							heading="Personnel Roles"
							store-location="service"
							job-type="Service"
							module="Services"
							v-on:fetchJob="fetchService">
						</personnel-tab>
						<p v-else>The service must be saved before assigning personnel to roles.</p>

						<div class="alert alert-info">
							<p><strong>The following roles are required:</strong></p>
							<ul class="required-role-list">
								<li v-for="role in requiredRoleListServices"><i class="fa" :class="hasRoleAssigned(role.id) ? 'fa-check' : 'fa-times'"></i> {{role.title}}</li>
							</ul>
						</div>
					</section>
					
					<section v-else-if="activeSection == 'Scheduling'">

						<schedule-component 
							:selected-date-external="$store.service.due_date"
							:service-id="$store.service.id"
							v-on:panelToggle="schedulePanelToggled">
						</schedule-component>

						<!--

						<div v-if="useNewSchedule">
							<div style="text-align: right;margin-bottom: 10px;">
								<button class="btn btn-light btn-sm" v-on:click="useNewSchedule = false">
									Switch to Old Scheduling
								</button>
							</div>
							<div style="clear: both;"></div>
							<schedule-component 
								:filters-external='scheduleFilters'
								:selected-date-external="$store.service.due_date"
								:service-id="$store.service.id"
								v-on:panelToggle="schedulePanelToggled">
							</schedule-component>
						</div>
						
						<template v-else>
							<div class="mt-4 d-flex justify-content-between align-items-center">
								<h3>Scheduling</h3>
								<button class="btn btn-light btn-sm" v-on:click="useNewSchedule = true">
									Switch to New Scheduling
								</button>
							</div>

							<div v-if="hasAllRequiredRoles" class="row">
								<div class="col-md-6">
									<h4>Appointment</h4>

									<field label="Start Date"
										col-class="col-6 col-sm-4 col-md-5"
										v-model="$store.service.due_date" 
										:params="{type: 'date'}" 
										:readonly="readonly" 
										:invalid="$store.errorList.due_date"
										v-on:change="fetchAvailableTechs()">
									</field>

									<field label="Appointment Time"
										col-class="col-6 col-sm-4 col-md-5"
										v-model="$store.service.appointment_time" 
										:params="{type: 'time'}" 
										:readonly="readonly" 
										:invalid="$store.errorList.appointment_time">
									</field>

									<field label="Multi-day?"
										col-class="col-6 col-sm-4 col-md-5"
										v-model="serviceIsMultiDay"
										:params="{type: 'boolean'}"
										:readonly="readonly"
										v-on:change="multiDayChange">
									</field>

									<field v-if="serviceIsMultiDay"
										label="End Date"
										col-class="col-6 col-sm-4 col-md-5"
										v-model="$store.service.end_date" 
										:params="{type: 'date'}" 
										:readonly="readonly" 
										:invalid="$store.errorList.end_date"
										v-on:change="fetchAvailableTechs()">
									</field>

									<field v-else-if="serviceIsMultiDay == 0"
										label="Est. Duration (hrs)"
										col-class="col-6 col-sm-4 col-md-5"
										v-model="$store.service.estimated_time" 
										:params="{type: 'number',min:0,step:0.25}" 
										:readonly="readonly" 
										:invalid="$store.errorList.estimated_time">
									</field>

								</div>
								<div class="col-md-6">
									<h4>Crew Members</h4>

									<field 
										label="Lead" 
										col-class="col-sm-4 col-md-5 col-lg-4" 
										v-model="$store.service.assigned_to" 
										:params="{type: 'select',options:availableTechsOptions,placeholder:'Add a lead technician'}" 
										:readonly="readonly" :invalid="$store.errorList.assigned_to">
									</field>

									<field 
										label="Helpers" 
										col-class="col-sm-4 col-md-5 col-lg-4" 
										v-model="helperTechs" 
										:params="{
											type: 'select-multi',
											options:availableTechsOptions,
											expandedStyling:true,
											placeholder: 'Add a helper'
										}" 
										:readonly="readonly">
									</field>

									<p class="text-muted">If a user has an event booked on the service appointment day(s) they will not be shown in the list.</p>

								</div>
							</div>
							<div v-else class="alert alert-warning">
								You must assign the following roles to this service before it can be scheduled:

								<ul style="margin-bottom: 0">
									<li v-for="role in requiredRoleList">{{role.title}}</li>
								</ul>
							</div>
						
						</template>
					-->
						
					</section>

					<section class="mt-3 mb-2" :class="{'thin-section': activeSection == 'Details' || activeSection == 'Setup Options'}">
						<button v-if="activeSection != 'Customer & Contract'" type="button" class="btn btn-light float-left" v-on:click="prevStep">
							<i class="fa fa-chevron-left"></i> Previous Step
						</button>

						<button v-if="activeSectionIndex < serviceSections.length - 1 || isQuote" :disabled="statusWorking" type="button" class="btn btn-light float-right" v-on:click="nextStep">
							Next Step <i class="fa fa-chevron-right"></i>
						</button>

						<div style="clear: both;"></div>
					</section>

				</template>
				
			</collapsible-panel>
			<div v-else>

				<div v-if="emergencyPanelVisible" class="text-center">
					<h2>What kind of job is this?</h2>

					<!--<field v-model="$store.service.is_emergency"
						:params="{
							type: 'btn-group',buttons:[
								{text: 'Emergency Work Order',icon:'fa-exclamation-triangle',value:true},
								{text: 'Regular Service/Small Job',icon:'fa-cube',value:false},
							],
							largeButtons: true
						}">
					</field>-->

					<div>
						<button class="btn btn-lg btn-outline-danger" type="button" v-on:click="newEmergency">
							<i class="fa fa-exclamation-triangle"></i>
							Emergency Work Order
						</button>
						<button class="btn btn-lg btn-light" type="button" v-on:click="newRegular">
							<i class="fa fa-cube"></i>
							Regular Service/Small Job
						</button>
						<router-link v-if="hasModulePermWrite('Service Quotes/Invoices')" class="btn btn-lg btn-info" to="/service/new-quote/details">
							<i class="fa fa-file-invoice-dollar"></i>
							Quote
						</router-link>
					</div>

					<div class="panel">
						<h5>What is an Emergency Work Order?</h5>

						<p>Emergency work orders allow a crew member to <strong>quickly create a service job and bypass the office dispatch step</strong>. It will require only the bare minimum to be filled out, and then dispatch the job to the employee who created it.</p>

						<p>It will also be flagged as an emergency service in the list, so adminstrative personnel will know to follow up with it when they are able.</p>
					</div>

					<hr>

				</div>

				<div class="text-center">
					<button v-if="!copyPanelVisible" type="button" class="btn btn-light" v-on:click="copyFromService">
						<i class="fa fa-copy"></i>
						Copy from another Service Work Order...
					</button>
				</div>

				<div v-if="copyPanelVisible" class="panel">

					<h2 class="text-center">Copy from another Service Work Order</h2>

					<div class="d-flex justify-content-center align-items-center">
						<label class="mb-0 mr-2">Service WO # to copy</label>

						<job-picker
							class="mr-2"
							:hide-label="true"
							col-class="col-md-4" 
							job-type="service"
							v-model="copyFromServiceId">
						</job-picker>

						<button type="button" class="btn btn-success" v-on:click="confirmCopyFromService">
							<i class="fa fa-check"></i>
							Copy
						</button>
					</div>
				</div>

			</div>

			<template v-if="$store.service && 'ServiceInvoice' in $store.service && $store.service.ServiceInvoice.find(inv => inv.is_quote == 1)" slot="buttons">
				<router-link class="btn btn-dark ml-1" :to="'/service/'+$store.service.slug+'/quote'">
					Go to Quote
					<i class="fa fa-chevron-right"></i>
				</router-link>
			</template>

		</vue-form>

		<modal-dialog
			title="Delete Service"
			:modal-visible="deleteServiceModalVisible"
			confirm-button-text="Yes, Delete"
			button-class="btn-outline-danger"
			v-on:closeModal="deleteServiceModalVisible = false"
			v-on:confirm="deleteService">

			Are you <strong>absolutely</strong> sure you want to delete this service? This action is unrecoverable.

		</modal-dialog>

		<modal-dialog :modal-visible="templatesModalVisible"
			title="Copy from a Quote Template"
			:submit-visible="false"
			v-on:closeModal="templatesModalVisible = false">

			<p>Pick a template to copy from</p>

			<table-list record-name="Quote Template"
				:fields="[{label:'Description',key:'quote_description'}]"
				:records="quoteTemplates"
				:has-edit="true"
				:hide-record-count="true"
				edit-button-text="Select"
				edit-button-icon="fa-copy"
				v-on:edit="pickTemplateToCopy">
			</table-list>
		</modal-dialog>

		<contact-location-edit-modal
			:visible="locationModal.visible"
			:contact-id="$store.service.customer_id"
			:record="locationModal.record"
			v-on:locationSaved="newLocationSaved"
			v-on:closeModal="locationModal.visible = false">
		</contact-location-edit-modal>

		<modal-dialog
			title="Process Expenses and Archive Service"
			:modal-visible="processExpensesModal.visible"
			confirm-button-text="Yes, Process All Expenses & Archive"
			cancel-button-text="No"
			:working="processExpensesModal.working"
			v-on:closeModal="processExpensesModal.visible = false"
			v-on:confirm="confirmProcessAllExpenses">

			There are unprocessed expenses attached to this project -- would you like to mark all of them as processed and then archive the project?

		</modal-dialog>

	</div>
</template>
<script type="text/javascript">
import ServiceToolbar from "./ServiceToolbar"

import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import PanelMenu from "@/components/PanelMenu"

import CustomerSection from "./service_sections/CustomerSection"
import CategorizationSection from "./service_sections/CategorizationSection"
import HeadingWidget from "@/components/HeadingWidget"

import VueForm from "@/components/VueForm"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import VueMap from "@/components/VueMap"
import JobMap from "@/components/JobMap"
import FormGroup from "@/components/FormGroup"
import TableList from "@/components/TableList"
import ContactTable from "@/components/super_components/ContactTable"
import AddressManualSelector from "@/components/AddressManualSelector"
import Alert from "@/components/Alert"
import PersonnelTab from "@/pages/project/PersonnelTab"
import ContactLocationEditModal from "@/components/super_components/ContactLocationEditModal"
import JobPicker from "@/components/super_components/JobPicker"

import ScheduleComponent from "@/components/schedule/ScheduleComponent"

import QboJobSyncAlert from "@/components/super_components/QboJobSyncAlert"

import ServiceMixins from "@/mixins/ServiceMixins.js"
import JobMixins from "@/mixins/JobMixins.js"
import InvoiceMixins from "@/mixins/InvoiceMixins.js"
import ServiceContractMixins from "@/mixins/ServiceContractMixins.js"
	
export default {
	name: "ServiceDetails",
	components: {
		ServiceToolbar,
		CollapsiblePanel,
		PanelMenu,
		CustomerSection,
		CategorizationSection,
		VueForm,
		Field,
		TableList,
		ContactTable,
		FormGroup,
		VueMap,
		JobMap,
		ModalDialog,
		AddressManualSelector,
		Alert,
		HeadingWidget,
		PersonnelTab,
		QboJobSyncAlert,
		ScheduleComponent,
		ContactLocationEditModal,
		JobPicker
	},
	mixins: [ServiceMixins,JobMixins,ServiceContractMixins,InvoiceMixins],
	data() {
		return {
			statusWorking: false,
			dropMarkers: [
				{
					lat: 43.5,
					lng: -79.5,
					draggable: true
				}
			],
			processExpensesModal: {
				visible: false
			},
			availableTechs: [],
			helperTechs: [],
			customerLocations: [],
			customerServiceContractOptions: [],
			customerAssets: [],
			formChildTemplates: [],
			checklists: [],
			deleteServiceModalVisible: false,
			belongsToProject: false,
			serviceIsMultiDay: null,
			activeSection: "Details",
			availableTechsPulled: false,
			emergencyPanelVisible: true,
			copyPanelVisible: false,
			copyFromServiceId: null,
			quoteTemplates: [],
			templatesModalVisible: false,
			selectedTemplateToCopy: null,
			showDirectionsOnMap: false,
			showHeaderStatusSelect: false,
			schedulePanelOpen: false,
			useNewSchedule: false,
			addressChangeWarningVisible: false,
			locationModal: {
				visible: false,
				record: {}
			},
			selectedFormChildTemplateIds: [],
			selectedChecklistIds: [],
			defaultsSet: false,
			selectedCustomerAssetIds: [],
			defaultSettings: {}
			/*serviceSections: [
				'Customer & Contract',
				'Details',
				"Personnel Roles",
				'Categorization',
				'Contacts',
				'Location',
				'Setup Options',
				'Scheduling'
			]*/
			//showExistingService: this.$route.params.id == 'new' ? false : true
		}
	},
	watch: {
		'$store.service'() {
			try {
				this.helperTechs = JSON.parse(this.$store.service.helper_techs_json)
			}
			catch (x) {}

			if (this.$store.service.end_date)
				this.serviceIsMultiDay = 1
			else
				this.serviceIsMultiDay = 0

			this.updatePinLocation()

		},
		'$store.company'() {
			if (!this.defaultsSet) 
				this.setDefaultValues()
		}
	},
	computed: {
		customerAssetOptions() {
			return this.optionify(this.customerAssets, 'description')
		},
		checklistOptions() {
			return this.optionify(this.checklists, 'name')
		},
		formChildTemplateOptions() {
			return this.optionify(this.formChildTemplates, 'description')
		},
		scheduleFilters() {
			let vm = this

			if ("ScheduleEvent" in this.$store.service && this.$store.service.ScheduleEvent.length > 0) {
				return {
					mainTypes: ["service","user"],
					projectIds: [],
					serviceIds: [this.$store.service.id],
					equipmentIds: [],
					userIds: [],
					showOnlyRelated: true
				}
			}
			else
				return false
		},
		availableTechsOptions() {
			let vm = this

			return this.optionify(this.$store.users.map(user => {

				let isAvailable = vm.availableTechs.find(availableUser => availableUser.id == user.id)

				if (isAvailable || !vm.availableTechsPulled)
					user.fullName = user.first_name+ " "+ user.last_name

				else
					user.fullName = user.first_name+" "+user.last_name+" (unavailable)"

				return user

			}),"fullName")
		},
		activeSectionIndex() {
			let activeSectionText
			if (typeof this.activeSection == 'object') 
				activeSectionText = this.activeSection.text
			else
				activeSectionText = this.activeSection

			return this.serviceSections.findIndex(section => {
				if (typeof section == 'object' && section.text == activeSectionText)
					return true
				else if (typeof section == 'string' && section == activeSectionText)
					return true
			})
		},
		serviceSections() {
			/*let sections = [
				'Customer & Contract',
				'Work Details'
			]*/

			let sections = [
				"Details"
			]

			//if (!this.$store.service.contract_id)
			//	sections.push("Categorization")

			sections.push('Work Location')

			if (!this.$store.service.is_emergency || !this.isNew)
				sections.push("Setup Options")

			if (!this.$store.service.is_emergency || !this.isNew)
				sections.push("Contacts")

			if (!this.hasAllRequiredRoles && !this.isNew)
				sections.push({text:"Personnel Roles",icon:'fa-exclamation-circle text-danger'})

			else if(!this.$store.service.is_emergency || !this.isNew)
				sections.push({text:'Personnel Roles'})

			if (!this.$store.service.is_emergency  || !this.isNew) {
				if (this.isScheduled)
					sections.push({text:'Scheduling'})
				else
					sections.push({text:"Scheduling",icon:'fa-exclamation-circle text-danger'})
			}

			return sections

		},
		mutatedJobOptions() {

			let filteredJobss = this.$store.projects
			if (this.$store.service.customer_id > 0) {
				filteredJobss = this.$store.projects
					.filter(job => job.customer_id == this.$store.service.customer_id)
					.map(job => {
						job.jobNumberAndName = job.job_num +" : " + job.job_name
						return job
					})
			}


			let options = this.optionify(filteredJobss,"jobNumberAndName")

			options.unshift({
				text: "Not connected to a project",
				value: 0
			})

			return  options
		},
		customerLocationsOptions() {

			let options = this.optionify(this.customerLocations.map(location => {

				let tokens = []

				let fields = ['address', 'city', 'province', 'country']
				fields.forEach(field => {
					if (field in location && location[field])
						tokens.push(location[field])
				})

				location.locationDisplay = tokens.join(", ")

				if ("suite" in location && location.suite)
					location.locationDisplay = location.suite + "-" + location.locationDisplay

				if (location.location_name)
					location.locationDisplay = location.location_name+": " + location.locationDisplay

				return location
			}),"locationDisplay")

			options.unshift({value: 0,text:'Main Location'})

			return options
		},
		isNewEmergency() {
			if (this.$route.params.id == 'new' && "is_emergency" in this.$store.service && this.$store.service.is_emergency)
				return true
			else
				return false
		},
		readonly() {
			if (this.$store.service.archived == 0 || this.$route.params.id == 'new' || this.$route.params.id == "new-quote")
				return false
			else
				return true
		},
		/*
		mapsSrc() {
			let destination_query

			if (!this.$store.service.address || !this.$store.service.city) //this limits too many useless map requests since google charges an arm and a leg now
				return false

			if (this.$store.service.location_type == "address" || this.$store.service.location_type == 'contact-location') 
				destination_query = this.$store.service.address+"+"+this.$store.service.city+"+"+this.$store.service.province+"+"+this.$store.service.country+"+"+this.$store.service.postal_code
			else 
				destination_query = this.$store.service.lat+","+this.$store.service.long

			let src = ""

			if (this.$store.company && this.showDirectionsOnMap) {
				let office = this.$store.company.address+"+"+this.$store.company.city+"+"+this.$store.company.province+"+"+this.$store.company.country+"+"+this.$store.company.postal_code
				src = 'https://www.google.com/maps/embed/v1/directions?key='+this.$store.GoogleEmbedAPIkey+"&destination="+destination_query+"&origin="+office
			}
			else 
				src = 'https://www.google.com/maps/embed/v1/place?key='+this.$store.GoogleEmbedAPIkey+"&q="+destination_query

			return src
			
		},
		*/
		serviceContactFilters() {
			return JSON.stringify([
				["service_id",this.$store.service.id]
			])
		},
		serviceContactInclude() {
			return JSON.stringify([{
				model: "Contact",
				include: ["Contact"]
			}])
		},
		serviceIsCompleted() {
			let vm = this

			let status = this.$store.serviceStatuses.find(status => status.label == this.$store.service.status)

			if (status) {
				if ("incompleteGroup" in status && status.incompleteGroup)
					return false
				else
					return true
			}
			return false
		},
		locationButtons() {
			let buttons = [
				{text: 'Customer Location',value:'contact-location'},
				{text: 'Address',value:'address'},
				{text: 'Lat/Lon',value:'coord'},
				{text: 'Drag a Pin',value:'pin'}
			]

			return buttons
		}
	},
	methods: {
		setDefaultValues() {

			this.defaultSettings = {}
			try {
				this.defaultSettings = JSON.parse(this.$store.company.CompanySetting.job_defaults_json)
			}
			catch (e) {}

			let keys = [
				"write_restricted",
				"read_restricted",
				"pays_perdiem",
				"pays_mileage",
				"check_in_tolerance",
				"payboost_ids",
				"work_to_do_disabled",
				"work_orders_disabled"
			]

			let vm = this

			keys.forEach(key => {
				if (key in vm.defaultSettings)
					vm.$store.service[key] = vm.defaultSettings[key]
			})

			vm.defaultsSet = true
		},
		newLocationSaved(location_id) {
			const vm = this

			this.getJSON("ContactLocation/find/" + location_id, false, true).then(response => {
				if (response.data) {
					vm.customerLocations.push(response.data)
					vm.$store.service.contact_location_id = location_id
					vm.$store.service.location_type = 'contact-location'
					vm.contactLocationChange(location_id)
				}
			})
		},
		openLocationModal(locationData = false) {

			const fields = ['suite', 'address', 'city', 'province', 'country', 'postal_code']
			let location = {}

			if (locationData) {
				fields.forEach(field => {
					if (field in locationData && locationData[field])
						location[field] = locationData[field]
				})
			}

			this.locationModal.visible = true
			this.locationModal.record = location
		},
		locationTypeChange(newType) {
			if (newType != 'contact-location') {
				this.customerAssets = []
				this.selectedCustomerAssetIds = []
			}
		},
		preopulateAppointmentDateTime() {
			this.$store.service.due_date = this.moment().format("YYYY-MM-DD")

			if (this.moment().minutes() > 30)
				this.$store.service.appointment_time = this.moment().add(30,"minutes").format("HH:00")
			else
				this.$store.service.appointment_time = this.moment().format("HH:30")
		},
		activateSection(item) {
			if (typeof item == 'object')
				this.activeSection = item.text
			else
				this.activeSection = item

			let slug = this.activeSection.slugify()

			if (slug == 'location')
				this.fetchCustomerLocations()

			window.history.pushState({},"","/service/"+this.$route.params.id+"/details/"+slug)
		},
		changeStep(cnt) {
			let vm = this

			//find index of current and minus one
			//this.activeSection = this.serviceSections[this.serviceSections.indexOf(this.activeSection)-1]

			let activeSectionObject = this.serviceSections[this.activeSectionIndex+cnt]

			this.activateSection(activeSectionObject)
		},
		prevStep() {
			this.changeStep(-1)
		},
		nextStep() {
			if (this.activeSection == 'Setup Options' && this.isNew) {
				this.saveService()
				this.changeStep(+1)
			}
			else if (this.activeSection == "Location" && this.isNew && this.isQuote)
				this.saveService()
			else if (this.activeSection == 'Personnel Roles' && this.isQuote) {
				this.saveService().then(response => {
					this.$router.push("/service/"+this.$route.params.id+"/quote")
				})
			}
			else if (this.activeSection == 'Scheduling' && this.isQuote) {
				this.saveService().then(response => {
					this.$router.push("/service/"+this.$route.params.id+"/quote")
				})
			}

			/*
			else if (this.activeSection == 'Work Location' && this.isQuote) {
				this.saveService(true).then(response => {
					this.$router.push("/service/"+response.data.slug+"/quote")
				})
			}
			*/
			else
				this.changeStep(+1)
		},
		schedulePanelToggled(open) {
			this.schedulePanelOpen = open
		},
		newEmergency() {
			this.$store.service.is_emergency = 1
			this.emergencyPanelVisible = false

			this.preopulateAppointmentDateTime()
		},
		categorySelected(catId) {
			//fetch and set default child templates and default checklists

			let vm = this
			this.getJSON("Category/find/"+catId,{include: ["Checklist","FormChildTemplate"]}).then(response => {

				if ("Checklist" in response.data && response.data.Checklist) {
					vm.selectedChecklistIds = response.data.Checklist.map(cl => cl.id)
				}
				if ("FormChildTemplate" in response.data && response.data.FormChildTemplate) {
					vm.selectedFormChildTemplateIds = response.data.FormChildTemplate.map(template => template.id)
				}
			})
		},
		newRegular() {
			this.$store.service.is_emergency = 0
			this.emergencyPanelVisible = false
		},
		copyFromService() {
			this.emergencyPanelVisible = false
			this.copyPanelVisible = true
		},
		confirmCopyFromService() {
			let vm = this

			let service = {}

			vm.spinner(true)

			this.getJSON("Service/find/"+this.copyFromServiceId).then(response => {
				if (response.success) {
					let payload = vm.cloneObj(response.data)

					delete payload.completed
					delete payload.archived
					delete payload.id
					delete payload.slug
					delete payload.job_num
					delete payload.tenant_id
					delete payload.due_date
					delete payload.end_date
					delete payload.appointment_time
					delete payload.scheduled_datetime
					delete payload.qbo_id

					payload.date_landed = vm.moment().format("YYYY-MM-DD")
					payload.status = "Draft"

					vm.postData("Service/save",payload,true).then(saveResponse => {
						vm.spinner(false)

						if (saveResponse.success) 
							vm.$router.push("/service/"+saveResponse.data.slug+"/details")
						
					})
				}
			})
		},
		copyFromQuoteTemplate() {
			let vm = this

			this.templatesModalVisible = true

			vm.spinner(true)

			this.getJSON("ServiceQuoteTemplate/get").then(response => {
				vm.spinner(false)
				if (response.success)
					vm.quoteTemplates = response.data
			})
		},
		pickTemplateToCopy(template) {
			this.fetchQuoteTemplate(template.slug) //have to set the selected template for further down the line

			let vm = this

			let fieldsToCopy = [
				"category_id",
				"revenue_code_id",
				"work_to_do"
			]

			fieldsToCopy.forEach(field => {
				vm.$set(vm.$store.service,field,template[field])
			})

			if ("work_to_do" in template && template.work_to_do)
				vm.$set(vm.$store.service,"description",template.work_to_do)

			if ("quote_description" in template && template.quote_description)
				vm.$set(vm.$store.service,"job_name",template.quote_description)

			vm.templatesModalVisible = false
		},
		cancelService() {
			let vm = this

			let payload = {
				id: vm.$store.service.id,
				status: 'Canceled',
				canceled_reason: vm.$store.service.canceled_reason
			}

			vm.postData("Service/save",payload).then(response => {
				if (response.success) {
					vm.alertSaved("Service job canceled")
					vm.fetchService()
				}
			})
		},
		statusChange(value,saveAfter) {
			let vm = this

			this.$nextTick(() => {
				//find the currently selected status in the list of statuses, if it ins an "imcomplete" status, set the completed date field back to null
				let status = vm.$store.serviceStatuses.find(st => st.label == vm.$store.service.status)

				if (status && "incompleteGroup" in status && status.incompleteGroup)
					vm.$store.service.completed = null

				if (saveAfter && "id" in vm.$store.service) {

					if (value == 'Canceled') {
						//don't save yet because we need a reason
					}
					else {
						let payload = {
							id: vm.$store.service.id,
							status: vm.$store.service.status
						}

						vm.postData("Service/save",payload).then(response => {
							if (response.success) {
								vm.alertSaved("Status updated")

								if (vm.serviceStatusIsCompletedGroup(vm.$store.service.status) && vm.$store.service.completed) {
									vm.showHeaderStatusSelect = false
								}
								else if (vm.serviceStatusIsCompletedGroup(vm.$store.service.status) && !vm.$store.service.completed)
									vm.showHeaderStatusSelect = true
								else if (vm.$store.service.status == 'Canceled' && vm.$store.service.canceled_reason) {
									vm.showHeaderStatusSelect = false
								}
								else if (vm.$store.service.status == 'Canceled' && !vm.$store.service.canceled_reason) {
									vm.showHeaderStatusSelect = true
								}
								else
									vm.showHeaderStatusSelect = false
							}
						})
					}
				}
			})
		},
		multiDayChange() {
			if (this.serviceIsMultiDay)
				this.$store.service.estimated_time = 0
			else
				this.$store.service.end_date = null
		},
		updateLocation(address) {
			let vm = this

			if ("id" in this.$store.service)
				this.addressChangeWarningVisible = true

			Object.keys(address).forEach((key,index) => {
				vm.$set(vm.$store.service,key,address[key])
			})

			if (!("lat" in address) || !("long" in address)) {
				this.$store.service.lat = false
				this.$store.service.long = false
			}
		},
		serviceStatusIsCompletedGroup(status) {
			let vm = this

			let statusFromList = this.$store.serviceStatuses.find(statusFromList => status == statusFromList.label)

			if (!statusFromList || (statusFromList && "incompleteGroup" in statusFromList && statusFromList.incompleteGroup))
				return false
			else
				return true
		},
		contractSelected(contract_id) {
			let vm = this

			if (contract_id > 0) {

				vm.fetchContract(contract_id).then(response => {
					if (response.success) {
						vm.$bus.$emit("contractIdChange",response.data.id)
						vm.$store.service.contract_id = response.data.id
						vm.$store.service.ServiceContract = response.data
						vm.$store.service.customer_po = response.data.customer_po
					}
				})
			}
			else {
				vm.$bus.$emit("contractIdChange",null)
				vm.$store.service.contract_id = null
				delete vm.$store.service.ServiceContract
			}

		},
		contractOptionsChange(data) {
			this.customerServiceContractOptions = this.optionify(data,'contract_description')
			if (data.length == 0)
				this.$store.service.contract_id = 0
		},
		contactLocationChange(location_id) {
			let vm = this

			let selectedAddress = vm.customerLocations.find(loc => loc.id == location_id)

			if (selectedAddress) {
				let copyFields = ["suite","address","city","province","country","postal_code","lat","long"]

				copyFields.forEach(field => {
					vm.$store.service[field] = selectedAddress[field]
				})
			}
			else if (location_id === 0 && "Customer" in this.$store.service && this.$store.service.Customer) {

				let copyFields = ["suite","address","city","province","country","postal_code"]

				copyFields.forEach(field => {
					vm.$store.service[field] = this.$store.service.Customer[field]
				})
			}

			this.$nextTick(() => {
				this.fetchCustomerAssets(this.$store.service.customer_id, this.$store.service.contact_location_id)
			})
		},
		workToDoChange() {
			if ("id" in this.$store.service)//only set up autosave if service was previously saved
				this.debounce('saveService',false,10000)
		},
		archiveService() {
			let vm = this

			let archived = 0;
			if (this.$store.service.archived == 0)
				archived = 1

			return new Promise((resolve,reject) => {
				vm.postData("Service/save",{id: this.$store.service.id, archived: archived}).then(response => {

					if (response.success) 
						vm.$store.service.archived = archived
					else if (!response.success && "errors" in response) {
						if (response.errors && "archived" in response.errors && response.errors.archived == "Can't archive, there are unprocessed expenses attached to it") {
							//offer to submit all logs and then archive the service
							vm.processExpensesModal.visible = true
						}
						else
							vm.alertErrors(response.errors)
					}
					resolve(response)
				})
			})
		},
		confirmProcessAllExpenses() {
			let vm = this

			this.processExpensesModal.working = true

			//fetch all the unprocessed expenses on this service
			let params = {
				filters: [
					["service_id",this.$store.service.id],
					["processed",0]
				]
			}
			this.getJSON("Expense/get",params).then(response => {
				if (response.success) {
					let payload = {
						records: JSON.stringify(response.data.map(exp => {
							return {
								id: exp.id,
								processed: 1
							}
						}))
					}

					vm.postData("Expense/save-batch",payload,true).then(response => {
						vm.processExpensesModal.working = false

						if (response.success) {
							vm.archiveService().then(response => {
								if (response.success)
									vm.processExpensesModal.visible = false
							})
						}
					})
				}
			})
		},
		/*saveServiceChecklists() {
			if (!('ServiceChecklist' in this.$store.service && this.$store.service.ServiceChecklist))
				return

			let selectedChecklists = this.checklists.filter(checklist => this.selectedChecklistIds.indexOf(checklist.id) >= 0)

			console.log(this.selectedChecklistIds, this.$store.service.ServiceChecklist)

			let toDelete = this.$store.service.ServiceChecklist.filter(checklist => this.selectedChecklistIds.indexOf(checklist.id) == -1)

			console.log(toDelete)

		},
		*/
		saveServiceChecklists() {
			const vm = this

			if (!('JobChecklist' in this.$store.service && this.$store.service.JobChecklist))
				return

			const currentSC = this.$store.service.JobChecklist

			//====================================================================
			// Handle checklists associated with SERVICE

			// ServiceChecklists currently linked only to the service (not a category or asset)
			const currentServiceSC = currentSC.filter(sc => sc.service_id == this.$store.service.id)

			// Delete removed checklists, create added checklists
			const serviceSCToDelete = currentServiceSC.filter(sc => !this.selectedChecklistIds.includes(sc.checklist_id))
			const serviceSCToCreate = this.selectedChecklistIds.filter(id => !currentServiceSC.find(sc => sc.checklist_id == id))

			//====================================================================
			// Handle checklists associated with JOB CATEGORY

			// Regular checklists linked to the job category
			const currentCategorySC = currentSC.filter(sc => sc.category_id > 0)    // existing ServiceChecklists linked to a category
			const newCategory = this.$store.categories.find(category => category.id == this.$store.service.category_id)
			const newCategoryChecklists = (newCategory && 'Checklist' in newCategory && newCategory.Checklist) ? newCategory.Checklist : []

			// Delete checklists associated with old category. Create checklists associated with new one.  Update checklists that are on both categories to new category id (so that progress is not lost)
			const categorySCToUpdate = currentCategorySC.filter(sc => newCategoryChecklists.find(checklist => checklist.id == sc.checklist_id))
			const categorySCToDelete = currentCategorySC.filter(sc => !newCategoryChecklists.find(checklist => checklist.id == sc.checklist_id))
			const categorySCToCreate = newCategoryChecklists
				.filter(checklist => !currentCategorySC.find(sc => sc.checklist_id == checklist.id))
				.map(checklist => checklist.id)

			//====================================================================
			// Create the promises

			// Individual /delete request for each checklist to delete
			const deletePromises = [
				...serviceSCToDelete.map(sc => this.postData('JobChecklist/delete', { id: sc.id })),
				...categorySCToDelete.map(sc => this.postData('JobChecklist/delete', { id: sc.id }))
			]

			let allPromises = [...deletePromises]

			function newRecord(checklist_id, category_id) {
				const fullChecklist = vm.checklists.find(fullChecklist => fullChecklist.id == checklist_id)
				return {
					service_id: vm.$store.service.id,
					checklist_id: checklist_id,
					category_id: category_id,
					name: fullChecklist.name,
					items_json: fullChecklist.items_json
				}
			}

			function updatedRecord(record_id) {
				return {
					id: record_id,
					category_id: vm.$store.service.category_id
				}
			}


			// Single /save-batch request containing every checklist to create/update
			if (serviceSCToCreate.length || categorySCToCreate.length || categorySCToUpdate.length) {

				let batchPromiseRecords = [
					...serviceSCToCreate.map(checklistId => newRecord(checklistId, 0)),                       // Create checklists that have been added manually
					...categorySCToCreate.map(checklistId => newRecord(checklistId, vm.$store.service.category_id)),    // Create checklists that are only on new category
					...categorySCToUpdate.map(sc => updatedRecord(sc.id))                                               // Re-link old category's checklists to new category if they exist on both
				]

				//filter out duplicates
				let filtered = []
				batchPromiseRecords.forEach(record => {
					if (!filtered.find(filteredRecord => filteredRecord.checklist_id == record.checklist_id))
						filtered.push(record)
				})
				batchPromiseRecords = filtered

				const createPromise = this.postData('JobChecklist/save-batch', {records: JSON.stringify(batchPromiseRecords)})
				allPromises.push(createPromise)
			}

			//====================================================================
			// Save results

			Promise.all(allPromises).then(responses => {

				// Refetch service checklists
				const refetchParams = {
					filters: [['service_id', vm.$store.service.id]]
				}

				vm.getJSON('JobChecklist/get', refetchParams).then(response => {
					if (response.success)
						vm.$store.service.JobChecklist = response.data
				})
			})
		},
		saveService(noRedirect) {
			let vm = this

			//if job is scheduled, and is still in quote status, change to Dispatched
			if (this.$store.service.assigned_to > 0 && this.$store.service.status == 'Quote' && this.$store.service.due_date)
				this.$store.service.status = "Dispatched"

			let payload = JSON.parse(JSON.stringify(this.$store.service))

			let remove = [
				"ServiceContact",
				"Category",
				"ServiceContract",
				"Contact",
				"Customer",
				"UpdatedBy",
				"AssignedTo",
				"User",
				"WorkCompletedBy",
				"JobPersonnelRole",
				"archived",
				"TimeLog",
				"ServiceFile",
				"ServiceInvoice",
				"Expense",
				"SafetyForm",
				"ServiceWorksheet",
				"JobChecklist",
				"FormChildTemplate",
				"CustomerAsset",
				"Checklist",
				"ScheduleEvent",
				"BatchInvoice"
			];

			remove.forEach(prop => {
				if (prop in payload)
					delete payload[prop]
			})

			payload.PayBoost = this.$store.service.payboost_ids
			delete payload.payboost_ids

			payload.helper_techs_json = JSON.stringify(this.helperTechs)

			payload.collective_agreements_json = JSON.stringify(this.$store.projectUnionCollectiveAgreements)

			payload.FormChildTemplate = this.selectedFormChildTemplateIds
			//payload.Checklist = this.selectedChecklistIds
			payload.CustomerAsset = this.selectedCustomerAssetIds

			this.statusWorking = true


			return new Promise((resolve,reject) => {

				vm.postData("Service/save",payload,true).then(response => {

					vm.statusWorking = false
					
					if (response.success) {

						if (!('id' in payload) && !('slug' in payload))
							vm.$set(vm.$store.service, 'id', response.record_id)

						if ('FormChildTemplate' in payload) {
							const formRecords = payload.FormChildTemplate.map(formChildTemplateId => { return {id: formChildTemplateId} })
							vm.$set(vm.$store.service, 'FormChildTemplate', formRecords)
						}

						// Save service checklists
						vm.saveServiceChecklists()

						if (vm.$route.params.id == 'new' && payload.is_emergency == 0 || vm.$route.params.id == 'new-quote') {
							/*window.history.replaceState({},"","/service/"+response.slug+"/details")
							vm.showExistingService = true

							vm.$route.params.id = response.slug

							vm.fetchService().then(fetchResponse => {
								vm.$store.service = fetchResponse.data
							})*/

							//get current active tab
							let segments = vm.segmentUrl(window.location.href)

							let tab = segments[segments.length-1]

							if (vm.$route.params.id == 'new-quote' && response.success) {
								
								let quotePayload = {
									is_quote: 1,
									service_id: response.data.record_id,
									work_completed_description: payload.description,
									skipQBOPush: true
								}

								let serviceSlug = response.data.slug

								quotePayload.applied_sales_tax_json = vm.compileDefaultTaxes()

								vm.postData("ServiceInvoice/save",quotePayload,true).then(invoiceResponse => {
									vm.statusWorking = false
									if (invoiceResponse.success) {
										if (vm.selectedTemplateToCopy && "ServiceQuoteTemplateObject" in vm.selectedTemplateToCopy && vm.selectedTemplateToCopy.ServiceQuoteTemplateObject) {
											//bring in the fields from the template

											let records = vm.selectedTemplateToCopy.ServiceQuoteTemplateObject.map(item => {
												let type = "", fieldValues
												if ("Material" in item && item.Material) {
													type = "Material"
													fieldValues = {
														qty: item.qty,
														part_number: item.Material.part_number,
														description: item.Material.description,
														price: item.Material.material_price,
														per: item.Material.per,
														labour_hrs: item.Material.labour_hrs
													}
												}
												else if ("EquipmentType" in item && item.EquipmentType) {
													type = "Equipment"

													let rate = +item.EquipmentType.charge_out_rate

													if ("charge_out_rates_json" in item.EquipmentType && item.EquipmentType.charge_out_rates_json) {

														try {
															let multiRates = JSON.parse(item.EquipmentType.charge_out_rates_json)

															if (item.unit in multiRates && multiRates[item.unit].enabled) {
																rate = multiRates[item.unit].rate
															}
														}
														catch (e) {}
													}

													let total = +item.qty * +rate

													fieldValues = {
														typeName: item.EquipmentType.name,
														equipment_type_id: item.EquipmentType.id,
														rate,
														qty: item.qty,
														unit: item.unit,
														total: total.toFixed(2) 
													}
												}
												else if ("ClassificationGroup" in item && item.ClassificationGroup) {
													type = "Labour"

													let total = +item.qty * +item.ClassificationGroup.charge_out_rate
													
													fieldValues = {
														hrs: item.qty,
														rate: item.ClassificationGroup.charge_out_rate,
														crew: 1,
														chargeOutGroupName: item.ClassificationGroup.label,
														group_id: item.ClassificationGroup.id,
														lineTotal: total.toCurrency(2)
													}
												}

												return {
													invoice_id: invoiceResponse.record_id,
													type,
													field_values_json: JSON.stringify(fieldValues)
												}

											}).filter(item => item.type && item.field_values_json)

											let invoiceObjectsPayload = {
												records: JSON.stringify(records)
											}

											vm.postData("ServiceInvoiceObject/save-batch",invoiceObjectsPayload,true).then(objectSaveResponse => {
												if (objectSaveResponse.success) {
													vm.alertSuccess("Quote created!")

													let activeSectionSlug = this.activeSection.slugify()

													if (vm.$route.params.id == 'new-quote')
														vm.$router.push("/service/"+serviceSlug+"/quote")
													else
														vm.$router.push("/service/"+serviceSlug+"/details/"+activeSectionSlug)

													//only redirect if we're on the location tab or personnel roles tab
													/*
													if (vm.activeSection == 'Personnel Roles')
														vm.$router.push("/service/"+serviceSlug+"/details/personnel-roles")
													else if (vm.activeSection == 'Location')
														vm.$router.push("/service/"+serviceSlug+"/details/location")
													*/
													resolve(response)
												}
											})
										}
										else {
											vm.alertSuccess("Quote created!")

											let activeSectionSlug = this.activeSection.slugify()

											if (!noRedirect)
												vm.$router.push("/service/"+serviceSlug+"/details/"+activeSectionSlug)

													//only redirect if we're on the location tab or personnel roles tab
													/*
													if (vm.activeSection == 'Personnel Roles')
														vm.$router.push("/service/"+serviceSlug+"/details/personnel-roles")
													else if (vm.activeSection == 'Location')
														vm.$router.push("/service/"+serviceSlug+"/details/location")
													*/

											resolve(response)
										}
									}
								})

								
							}
							else {
								vm.alertSaved("Service saved!")
								
								if (!noRedirect)
									vm.$router.push("/service/"+response.data.slug+"/details/"+tab)
								
								resolve(response)
							}
						}
						else if ((vm.$route.params.id == 'new' || vm.$route.params.id == 'new-quote') && payload.is_emergency == 1) {
							
							if (!noRedirect)
								vm.$router.push("/service/"+response.data.slug+"/dashboard")
							
							resolve(response)
						}

						vm.alertSaved("Service saved!")
						resolve(response)
					}	
				})
			})
		},
		setCoordsFromDroppedPin(position,marker) {

			this.$set(this.$store.service,"lat",Math.round(position.lat*100000)/100000)
			this.$set(this.$store.service,"long",Math.round(position.lng*100000)/100000)

			marker.lat = position.lat
			marker.lng = position.lng
		},
		updatePinLocation() {
			this.dropMarkers = []

			let lat = +this.$store.service.lat
			let long = +this.$store.service.long

			if (!lat)
				lat = +this.$store.company.lat
			if (!long)
				long = +this.$store.company.long

			this.dropMarkers.push({
				lat,
				lng: long,
				draggable: true
			})
		},
		deleteService() {
			let vm = this

			this.postData("Service/delete",{id:this.$store.service.id},true).then(response => {

				if (response.success) {
					vm.deleteServiceModalVisible = false
					vm.$router.push("/services")
				}
			})
		},
		fetchQuoteTemplate(slug) {
			let vm = this

			let params = {
				include: [
					{model: "ServiceQuoteTemplateObject",include:["Material","EquipmentType","ClassificationGroup"]}
				]
			}

			this.spinner(true)

			return new Promise((resolve,reject) => {
				vm.getJSON("ServiceQuoteTemplate/find/"+slug,params).then(response => {
					vm.spinner(false)
					if (response.success)
						vm.selectedTemplateToCopy = response.data

					resolve(response)
				})
			})
		},
		fetchCustomerAssets(customer_id, location_id) {
			const vm = this

			if (!customer_id) {
				vm.customerAssets = []
				return
			}

			if (!location_id)
				location_id = 0

			const params = {
				fields: ['id', 'slug', 'contact_id', 'location_id', 'description'],
				filters: [
					["contact_id", customer_id],
					["location_id", location_id]
				]
			}

			this.getJSON("CustomerAsset/get", params).then(response => {
				if (response.success)
					vm.customerAssets = response.data
			})
		},
		fetchCustomerLocations() {
			let vm = this

			let params = {
				filters: [
					["contact_id",this.$store.service.customer_id]
				]
			}

			let promises = [
				vm.getJSON("ContactLocation/get",params,true),
				vm.getJSON("Contact/find/"+this.$store.service.customer_id)
			]

			Promise.all(promises).then(responses => {
				
				vm.customerLocations = responses[0].data

				let customer = responses[1].data

				//show contact main address as a location
				vm.customerLocations.unshift(customer)
				vm.$store.service.CustomerAsset = customer
			})

		},
		fetchContacts() {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.getJSON("ServiceContact/get?filters="+vm.serviceContactFilters+"&include="+vm.serviceContactInclude).then(response => {
					vm.$store.service.ServiceContact = response.data

					resolve(response)
				})
			})
		},
		fetchAvailableTechs() {
			let vm = this

			if ("due_date" in this.$store.service && this.$store.service.due_date) {
				this.$nextTick(() => {

					let eventFilters = []
					if (vm.serviceIsMultiDay == 1) {
						eventFilters = [
							["start <=",vm.$store.service.end_date],
							["end >=",vm.$store.service.due_date]
						]
					}
					else {
						let dueDateEndofDay = vm.moment(vm.$store.service.due_date).format("YYYY-MM-DD 23:59:59")

						eventFilters = [
							["start <=",vm.$store.service.due_date],
							["end >=",vm.$store.service.due_date],
							["start >=",vm.$store.service.due_date,"or"],
							["start <=",dueDateEndofDay],
							["end",null]
						]
					}

					let params = {
						fields: ["id","first_name","last_name","email"],
						include: [
							{
								model: "Event",
								filters: eventFilters,
								fields: ["duration_hrs","user_id","start","end","is_vacation","is_sickday","title"],
								limit: 1
							}
						]
					}

					return new Promise((resolve,reject) => {
						vm.getJSON("User/get",params).then(response => {

							//if tech has an event, then we know its a conflic and he can't be scheduled
							vm.availableTechs = response.data.filter(user => {
								if ("Event"  in user && user.Event.length > 0)
									return false
								else
									return true
							})

							vm.availableTechsPulled = true

							resolve(response)
						})
					})
				})
			}
		},
		fetchFormChildTemplates() {
			const vm = this

			const payload = {
				fields: ['id', 'description']
			}

			return new Promise(resolve => {
				this.getJSON("FormChildTemplate/get", payload).then(response => {
					if (response.success)
						vm.formChildTemplates = response.data
					resolve(response)
				})
			})
		},
		fetchChecklists() {
			const vm = this

			return new Promise(resolve => {
				this.getJSON("Checklist/get").then(response => {
					if (response.success)
						vm.checklists = response.data
					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this

			this.spinner(true)

			let promises = [
				this.fetchContacts(),
				this.fetchJobCategories(),
				this.fetchCustomers(),
				this.fetchUsers([],false,["first_name","last_name","email"]),
				this.fetchUnions(),
				this.fetchRevenueCodes(),
				this.fetchServiceStatuses(),
				this.fetchJobs(["id","slug","job_num","job_name","customer_id"]),
				this.fetchJobPersonnelRoles(),
				//this.getJSON("SafetyForm/get",{filters: [["job_id <",1]]}),
				this.getJSON("PayBoost/get"),
				this.fetchFormChildTemplates(),
				this.fetchChecklists()
			]

			let includeServiceFetch = false
			if (this.$route.params.id != "new" && this.$route.params.id != 'new-quote') {
				includeServiceFetch = true
				promises.push(this.fetchService())
			}


			Promise.all(promises).then(responses => {

				vm.$store.payBoostOptions = vm.optionify(responses[9].data,"description")

				if (includeServiceFetch) {

					vm.$nextTick(() => {

						let lastIndex = promises.length-1

						vm.$set(vm.$store,"service",responses[lastIndex].data)

						if ('FormChildTemplate' in responses[lastIndex].data && responses[lastIndex].data.FormChildTemplate)
							vm.selectedFormChildTemplateIds = responses[lastIndex].data.FormChildTemplate.map(fct => fct.id)

						if ('Checklist' in responses[lastIndex].data && responses[lastIndex].data.Checklist)
							vm.selectedChecklistIds = responses[lastIndex].data.Checklist
								.map(checklist => checklist.id)

						if ('CustomerAsset' in responses[lastIndex].data && responses[lastIndex].data.CustomerAsset)
							vm.selectedCustomerAssetIds = responses[lastIndex].data.CustomerAsset.map(asset => asset.id)

						if (responses[lastIndex].data.Customer && "ContactLocation" in responses[lastIndex].data.Customer)
							vm.customerLocations = responses[lastIndex].data.Customer.ContactLocation

						vm.fetchCustomerAssets(responses[lastIndex].data.customer_id, responses[lastIndex].data.contact_location_id)
						
						if ("ServiceContract" in responses[lastIndex].data && responses[lastIndex].data.ServiceContract) {
							//get collective agreements from contract if there is one
							vm.$store.projectUnionCollectiveAgreements = []
							try {
								vm.$store.projectUnionCollectiveAgreements = JSON.parse(responses[lastIndex].data.ServiceContract.collective_agreements_json)
							}
							catch (e) {}
						}
						else if (responses[lastIndex].data.collective_agreements_json) {
							//otherwise get it from the service if no contract
							vm.$store.projectUnionCollectiveAgreements = []
							try {
								vm.$store.projectUnionCollectiveAgreements = JSON.parse(responses[lastIndex].data.collective_agreements_json)
							}
							catch (e) {}
						}
						else {
							//json is null, so we'll build our own with the list of unions
							let collective_agreements_obj = {}
							responses[3].data.forEach(union => {
								collective_agreements_obj[union.id] = 0
							})

							vm.$store.projectUnionCollectiveAgreements = collective_agreements_obj
						}

						if (responses[4].success) 
							vm.bindDefaultCollectiveAgreements(responses[4].data)

						vm.fetchCustomerContracts([
							["customer_id",responses[lastIndex].data.customer_id],
							["end_date >",vm.moment().format("YYYY-MM-DD")]
						]).then(response => {
							vm.contractOptionsChange(response.data)
						})

						try {
							vm.$store.ServiceContact = JSON.parse(vm.$store.service.ServiceContact)
						}
						catch (e){}

						try {
							vm.$store.materialsUsed = JSON.parse(vm.$store.service.parts_used_json)
						}
						catch (e){}

						try {
							vm.helperTechs = JSON.parse(vm.$store.service.helper_techs_json)
						}
						catch (e) {}

						if ("ServiceContract" in vm.$store.service && vm.$store.ServiceContract && Object.keys(vm.$store.service.ServiceContract).length > 0) {
							vm.$store.service.category_id = vm.$store.service.ServiceContract.category_id
							vm.$store.service.revenue_code_id = vm.$store.service.ServiceContract.revenue_code_id
						}

						/////////////////////////
						// HORRIBLE hack, because selects won't bind unless they change value after options are set ¯\_(ツ)_/¯
						/////////////////////////

						let selectFields = [
							"customer_id",
							"assigned_to",
							"revenue_code_id",
							"job_id",
							"category_id",
							"status",
							"is_emergency"
						]

						let values = []
						let unionValues = []

						//save the values so we can change them
						selectFields.forEach(key => {
							values.push(vm.$store.service[key])
							vm.$store.service[key] = ""
						})

						if (vm.$store.projectUnionCollectiveAgreements) {

							vm.$store.unions.forEach(union => {
								unionValues.push(vm.$store.projectUnionCollectiveAgreements[union.id])
								vm.$store.projectUnionCollectiveAgreements[union.id] = ""
							})
						}

						//now re-set the values
						vm.$nextTick(() => {
							selectFields.forEach((key,index) => {
								vm.$store.service[key] = values[index]
							})

							if (vm.$store.projectUnionCollectiveAgreements) {
								vm.$store.unions.forEach((union,index) => {
									vm.$store.projectUnionCollectiveAgreements[union.id] = unionValues[index]
								})

								//make sure ColAgreements are set to "Default" option if they are null
								Object.keys(vm.$store.projectUnionCollectiveAgreements).forEach(key => {
									if (vm.$store.projectUnionCollectiveAgreements[key] === null)
										vm.$store.projectUnionCollectiveAgreements[key] = 0
								})
							}

							vm.fetchAvailableTechs()

						})

						/////////////////////////
						// END of horrible hack
						/////////////////////////
					})
				}
				else {
					if (vm.$route.params.id == 'new-quote') 
						vm.$store.service.status = "Quote"
				}

				//auto-fill assigned_to to be user
				/*
					if (vm.userIsServiceTech() && vm.$route.params.id == "new")
						vm.$store.service.assigned_to = vm.$store.userDetails.id
				*/

				vm.spinner(false)
			})
		}
	},
	created() {

		if ("tag" in this.$route.params && this.$route.params.tag) {
			let slug = this.$route.params.tag

			let activeSection = this.serviceSections.find(section => {
				if (typeof section == 'object' && section.text.slugify() == slug)
					return true
				
				else if (typeof section == 'string' && section.slugify() == slug)
					return true

			})

			if (typeof activeSection == 'object')
				this.activeSection = activeSection.text
			else
				this.activeSection = activeSection
		}
		
		this.fetchData()

		if (this.$route.params.id == "new") {
			
			this.activeSection = "Details"
			window.history.replaceState({},"","/service/new/details/details")

			this.$store.service = {
				check_in_tolerance: 200,
				location_type: 'contact-location'
			}
			if ("CompanySetting" in this.$store.company && !this.defaultsSet)
				this.setDefaultValues()

			this.$store.errorList = {}

			if ("CompanySetting" in this.$store.company && this.$store.company.CompanySetting)
				this.setDefaultValues()

			if (this.userIsServiceTech() && (this.getUserRoleType() != "Admin" && !this.hasModulePermWrite("Services"))) {
				this.$store.service.is_emergency = 1
				this.$store.service.assigned_to = this.$store.userDetails.id

				this.preopulateAppointmentDateTime()
			}
		}
		else if (this.$route.params.id == "new-quote") {
			this.$store.service = {
				status: "",
				is_emergency: false,
				is_warranty_work: false,
				check_in_tolerance: 200
			}
			this.$store.errorList = {}
		}

	}
}
</script>

<style type="text/css" scoped>

	section {
		margin-top: 0;
	}

	.status-state {
		font-size: 18pt;
		text-transform: uppercase;
		padding: 2px;
		padding-left: 10px;
		padding-right: 10px;
	}

	.schedule-group {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.schedule-group .schedule-field {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex-grow: 1
	}

	.schedule-group .schedule-field div {
		flex-grow: 1;
	}

	.thin-section {
		max-width: 800px;
	}

	.required-role-list {
		margin-bottom: 0;
		list-style: none;
		padding-left: 15px;
	}

	.required-role-list .fa {
		margin-right: 10px;
	}

	.panel-filler {
		width: 250px;
		background-color: var(--background-light);
		margin-left: -15px;
		margin-top: -15px;
		margin-bottom: -15px;
		margin-right: 15px;					
	}

	@media (max-width: 1024px) {
		.panel-filler {
			display: none;
		}
	}

	@media (max-width: 820px) {
		.schedule-group {
			flex-wrap: wrap;
		}

		.schedule-group .schedule-field {
			flex-grow: 1;
			flex-basis: 100%;
		}

		.schedule-group .schedule-field label {
			flex-basis: 100px;
		}
	}
</style>